import { SET_HOMEPAGE_CATEGORIES } from "../actionTypes";
import { initialState } from "../initialState";

const homepageCategoriesReducer = (
    state = initialState.homepageCategories,
    action
) => {
    switch (action.type) {
        case SET_HOMEPAGE_CATEGORIES:
            return action.payload;
        default:
            return state;
    }
};

export default homepageCategoriesReducer;
